"use client";
import React, { useState } from "react";
import Carousel from "@/components/ui/Carousel";
// import StoreCard from "@/components/ui/StoreCard";
// import DealCard from "@/components/ui/DealCard";
// import OfferCard from "@/components/ui/OfferCard";
// import TabNav from "@/components/ui/TabNav";
// import NewsletterForm from "@/components/ui/NewsletterForm";
// import Image from "next/image";
import PopularOffersSection from "@/components/PopularOffersSection";
import PopularStoresSection from "@/components/PopularStoresSection";
import CategoriesSection from "@/components/CategoriesSection";
// import StatsSection from "@/components/StatsSection";
// import CashBackSection from "@/components/CashBackSection";
// import BankWalletSection from "@/components/BankWalletSection";
// import { apiFetch } from "@/utils/api";
// import BlogSection from "@/components/BlogSection";

// interface Offer {
//   _id?: string;
//   store: string;
//   storeIcon?: string;
//   title: string;
//   description: string;
//   discount: string;
//   category: string;
//   couponCode: string;
//   validTill: string;
//   usedBy: number;
//   rating: number;
//   color: string;
//   badge: string;
//   bgGradient: string;
//   slug: string;
//   allowRedirectUrl?: boolean;
//   redirectUrl?: string;
// }

// const featuredTabs = ["beauty", "fashion", "travel", "web-hosting", "food"];

export default function Home() {
  // const [activeTab, setActiveTab] = useState(featuredTabs[0]);
  // const [offers, setOffers] = useState<Offer[] | null>(null);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState<string | null>(null);

  // Email subscription state
  const [subEmail, setSubEmail] = useState("");
  const [subLoading, setSubLoading] = useState(false);
  const [subSuccess, setSubSuccess] = useState<string | null>(null);
  const [subError, setSubError] = useState<string | null>(null);

  // useEffect(() => {
  //   setLoading(true);
  //   apiFetch<unknown>("/offers")
  //     .then((res) => {
  //       let arr: unknown = [];
  //       if (Array.isArray(res)) {
  //         arr = res;
  //       } else if (res && typeof res === "object") {
  //         const obj = res as Record<string, unknown>;
  //         if (
  //           obj.data &&
  //           typeof obj.data === "object" &&
  //           Array.isArray((obj.data as Record<string, unknown>).offers)
  //         ) {
  //           arr = (obj.data as Record<string, unknown>).offers;
  //         } else if (Array.isArray(obj.offers)) {
  //           arr = obj.offers;
  //         } else if (Array.isArray(obj.data)) {
  //           arr = obj.data;
  //         }
  //       }
  //       setOffers(Array.isArray(arr) ? arr : []);
  //       setError(
  //         Array.isArray(arr) && arr.length === 0 ? "No offers found." : null
  //       );
  //     })
  //     .catch((err: unknown) => {
  //       const message =
  //         err && typeof err === "object" && "message" in err
  //           ? (err as { message?: string }).message
  //           : undefined;
  //       setError(message || "Failed to load offers");
  //       setOffers([]);
  //     })
  //     .finally(() => setLoading(false));
  // }, []);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubSuccess(null);
    setSubError(null);
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(subEmail)) {
      setSubError("Please enter a valid email address.");
      return;
    }
    setSubLoading(true);
    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: subEmail }),
      });
      if (!res.ok) throw new Error("Failed to subscribe");
      setSubSuccess(
        "Subscribed successfully! You'll receive the latest offers."
      );
      setSubEmail("");
    } catch (err) {
      setSubError((err as Error).message || "Failed to subscribe");
    } finally {
      setSubLoading(false);
    }
  };

  // Filter offers by activeTab/category
  // const filteredOffers =
  //   offers?.filter(
  //     (o) => o.category?.toUpperCase() === activeTab.toUpperCase()
  //   ) || [];

  return (
    <div className="bg-white ">
      <div className="flex flex-col gap-4">
        {/* Banner Carousel & Search */}
        <div className="w-full flex flex-col gap-4 items-center mt-4 md:mt-4 lg:mt-4 px-4 lg:px-8">
          <div className="w-full">
            <Carousel orientation="horizontal" />
          </div>
          <div className="w-full flex items-center justify-center gap-2 lg:gap-6 px-2 lg:px-4 pt-1 lg:pt-4">
            <div className="flex-grow h-px bg-gradient-to-r from-transparent via-primary-300 to-primary-500 opacity-60 hidden lg:flex" />

            <div className="px-6 py-2 rounded-full bg-white text-gray-700 text-xs lg:text-sm font-medium shadow-sm border border-primary-200 backdrop-blur-sm">
              Best Coupons & Deals Marketplace
            </div>

            <div className="flex-grow h-px bg-gradient-to-r from-primary-500 via-primary-300 to-transparent opacity-60 hidden lg:flex" />
          </div>
        </div>

        {/* Popular Stores */}
        <div className="py-4 px-4 bg-primary-100">
          <PopularStoresSection />
        </div>

        <div className="py-4 lg:px-8 px-4 bg-white">
          <PopularOffersSection />
        </div>

        <div className="py-4 lg:px-4 bg-primary-100">
          <CategoriesSection />
        </div>

        {/* Featured Offers Tabs */}
        {/* <div className="py-4 px-4 bg-white">
          <div className="px-4">
            <TabNav
              tabs={featuredTabs}
              activeTab={activeTab}
              onChange={setActiveTab}
            />
            <div
              className="flex gap-4 overflow-x-auto pb-2 scrollbar-hide"
              style={{ WebkitOverflowScrolling: "touch" }}
            >
              {loading &&
                Array.from({ length: 4 }).map((_, i) => (
                  <div
                    key={i}
                    className="animate-pulse bg-gray-200 rounded-lg h-48 w-64"
                    aria-busy="true"
                  />
                ))}
              {error && !loading && (
                <div className="col-span-full text-center text-red-500 py-8">
                  {error}
                </div>
              )}
              {!loading &&
                filteredOffers &&
                filteredOffers.length === 0 &&
                !error && (
                  <div className="col-span-full text-center text-gray-500 py-8 px-4 ">
                    No offers found.
                  </div>
                )}
              {!loading &&
                filteredOffers &&
                filteredOffers.map((offer, i) => (
                  <OfferCard
                    key={offer._id || i}
                    storeLogo={offer.storeIcon ?? null}
                    storeName={offer.store}
                    title={offer.title}
                    description={offer.description}
                    offersCount={offer.usedBy || 1}
                    badge={offer.badge}
                    validTill={offer.validTill}
                    slug={offer.slug}
                    allowRedirectUrl={offer.allowRedirectUrl}
                    redirectUrl={offer.redirectUrl}
                  />
                ))}
            </div>
          </div>
        </div> */}



        {/* <div className="py-4 px-4 bg-primary-100">
          <BankWalletSection />
        </div> */}

        {/* <div className="py-4 px-4 bg-primary-100">
          <CashBackSection />
        </div> */}

        {/* blog section */}
        {/* <div className="py-4 px-4">
          <BlogSection />
        </div> */}
        {/* <StatsSection /> */}
      </div>

      <div className="py-4 px-4 bg-white">
        <div id="emailSubscription" className="md:px-4">
          {/* Email subscription */}
          <div className=" bg-gradient-to-r from-primary-600/10 to-pink-500/10 rounded-2xl lg:p-8 p-4">
            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                <div>
                  <h3 className="lg:text-2xl font-bold mb-2 text-gray-500">
                    Get The Latest & Best Coupon/Offer Alerts
                  </h3>
                  <p className="text-gray-500 lg:text-sm text-xs mb-4">
                    35,00,000+ Subscriptions Across India & Counting!
                    Subscribe to have new coupon lists delivered directly to
                    your inbox
                  </p>
                  <form className="flex flex-row space-x-3 gap-0" onSubmit={handleSubscribe}>
                    <input
                      type="email"
                      placeholder="Enter Email Address"
                      className="flex-1 lg:px-4 px-2 py-3 rounded-xl border border-gray-200 bg-white lg:text-sm text-xs text-gray-600 focus:ring-1 focus:ring-purple-500 focus:outline-none focus:border-transparent lg:w-full"
                      value={subEmail}
                      onChange={(e) => setSubEmail(e.target.value)}
                      required
                      disabled={subLoading}
                    />
                    <button
                      type="submit"
                      className="bg-gradient-to-br from-primary-500 to-purple-500 hover:scale-105 text-xs lg:text-sm text-white rounded-xl px-3 lg:px-6 py-3 disabled:opacity-60 flex-shrink-0"
                      disabled={subLoading}
                    >
                      {subLoading ? "SUBSCRIBING..." : "SUBSCRIBE"}
                    </button>
                  </form>
                  {subSuccess && (
                    <div className="text-green-600 font-semibold mt-2">
                      {subSuccess}
                    </div>
                  )}
                  {subError && (
                    <div className="text-red-600 font-semibold mt-2">
                      {subError}
                    </div>
                  )}
                </div>
                <div className="hidden md:block">
                  <div className="text-center lg:text-right">
                    <div className="inline-block loading-shimmer ">
                      <div className="w-48 h-32  bg-gradient-to-br from-primary-500/20 to-indigo-500/20 rounded-xl flex items-center justify-center">
                        <div className="text-6xl animate-shake">📧</div>
                      </div>
                    </div>
                    <style jsx>{`
                      @keyframes shake {
                        0%,
                        100% {
                          transform: translateX(0);
                        }
                        20%,
                        60% {
                          transform: translateX(-2px);
                        }
                        40%,
                        80% {
                          transform: translateX(2px);
                        }
                      }
                      .animate-shake {
                        animation: shake 1.6s ease-in-out infinite;
                      }
                    `}</style>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter Subscription */}
      {/* <div className="w-full max-w-3xl mx-auto bg-primary-100 rounded-xl p-6 flex flex-col items-center">
        <h2 className="text-lg font-bold mb-2 text-primary-800">Get The Latest & Best Coupon/Offer Alerts</h2> */}
      {/* <NewsletterForm /> */}
      {/* </div> */}
    </div>
  );
}
